// extracted by css-extract-rspack-plugin
export default {"list":"Tab-module__list___ZH2Ng","tab":"Tab-module__tab___U4uPU","tabLabel":"Tab-module__tabLabel___oabm_","tabSection":"Tab-module__tabSection___ZSoxq"};